<template>
  <div class="o-layout__container">
    <nn-notification v-if="status === 'error'" type="error">
      {{ errorMessage }}
      <div>(code: {{ this.errorCode }})</div>
      <nn-button @click="redirectToLogin" class="c-button c-button--secondary">
        terug naar inloggen
      </nn-button>
    </nn-notification>

    <nn-notification v-if="status === 'timeout'" type="warning">
      <h2 class="notification-margin">Uw sessie is verlopen</h2>
      <p>
        De sessie verloopt na 15 minuten. Ga terug naar het inlog scherm en
        begin opnieuw
      </p>
      <nn-button @click="redirectToLogin" class="c-button c-button--secondary">
        terug naar inloggen
      </nn-button>
    </nn-notification>

    <div data-test="resetPasswordStepsContent" v-if="showStepsContent">
      <nn-stepper
        :steps="stepper.steps"
        :active-step="stepper.activeStep"
        @navigate="navigateStepper"
      />

      <nn-spinner v-if="status === 'loading'" />

      <div v-if="status !== 'loading'">
        <reset-password-content
          v-if="stepper.activeStep === 0"
          subheader="Vul je gebruikersnaam in om een nieuw wachtwoord aan te vragen."
          :error="status === 'error' ? errorMessage : ''"
        >
          <template v-slot:paragraph>
            <p>
              Als je gebruikersnaam bij ons bekend is ontvang je binnen enkele
              minuten een e-mail met een tijdelijk wachtwoord.
            </p>
          </template>

          <form @submit.prevent="resetPassword()" class="u-padding--30">
            <nn-input-field
              id="username"
              v-model="username"
              class="u-margin-bottom"
              >Gebruikersnaam (<a :href="config.forgotUsername"
                ><u>vergeten?</u></a
              >)
            </nn-input-field>
            <nn-button :disabled="!username" @click="resetPassword()"
              >Wachtwoord aanvragen</nn-button
            >
          </form>
        </reset-password-content>

        <reset-password-content
          v-if="stepper.activeStep === 1"
          subheader="Gebruik je gebruikersnaam en het tijdelijke wachtwoord in je e-mail om het account te koppelen."
          :error="status === 'error' ? errorMessage : ''"
        >
          <template v-slot:paragraph>
            <p>
              Als je gebruikersnaam bij ons bekend is ontvang je binnen enkele
              minuten een e-mail met een tijdelijk wachtwoord. Gebruik dit
              tijdelijke wachtwoord om je account met eHerkenning te koppelen.
            </p>
          </template>

          <couple-eherkenning
            password-reset-flow
            :usernameFromResetPassword="username"
            :config="config"
            @onHandleForgeRockError="handleForgeRockError($event)"
          />
        </reset-password-content>
      </div>
    </div>

    <already-coupled v-if="status === 'alreadyCoupled'" />

    <not-found
      v-if="status === 'notFound'"
      :contactNum="config.contactNum"
      :contactForm="config.contactForm"
    />
  </div>
</template>

<script>
import * as resetPasswordApi from "../utils/api";
import { forgeRockCodes, errorMessages } from "../amResponseCodes";
import ResetPasswordContent from "../components/ResetPasswordContent";
import CoupleEherkenning from "../components/CoupleEherkenning";
import { sendForgotPasswordStepsToAnalytics } from "../analytics";
import { redirect } from "@nn/psdl-utility/src/redirect";

export default {
  name: "ResetPassword",
  components: { ResetPasswordContent, CoupleEherkenning },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      username: "",
      errorCode: "",
      status: "",
      showStepsContent: true,
      stepper: {
        steps: ["Wachtwoord aanvragen", "Account koppelen", "Ingelogd"],
        activeStep: 0
      }
    };
  },
  mounted() {
    sendForgotPasswordStepsToAnalytics(this.stepper.steps[0]);
  },
  computed: {
    errorMessage() {
      return errorMessages[this.errorCode] || errorMessages.DEFAULT_ERROR_MESSAGE;
    }
  },
  methods: {
    async resetPassword() {
      this.errorCode = "";
      this.status = "loading";

      try {
        await resetPasswordApi.resetPassword(this.username);
        this.stepper.activeStep = 1;
        sendForgotPasswordStepsToAnalytics(this.stepper.steps[1]);
        this.status = 'done';
      } catch (e) {
        this.handleForgeRockError(e);
      }
    },
    redirectToLogin() {
      redirect(this.config.eHerkenningCancelPage);
    },
    handleForgeRockError(e) {
      this.status = "";
      this.errorCode = "";
      this.showStepsContent = false;

      if (e.message === forgeRockCodes.TIMEOUT) {
        this.status = "timeout";
      } else if (e.message === forgeRockCodes.ALREADY_COUPLED) {
        this.status = "alreadyCoupled";
      } else if (e.message === forgeRockCodes.NOT_FOUND) {
        this.status = "notFound";
      } else {
        this.status = "error";
        this.errorCode = e.message;
      }
    },
    navigateStepper(index) {
      this.stepper.activeStep = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-step-indicator-bullet {
  margin-bottom: 1rem;
}
</style>
